import React, { useContext } from 'react'
import { connect } from 'react-redux'
import { number, shape, func, string } from 'prop-types'

import { getSelectedRenderItemId } from 'models/compositions/selectors'
import { addToBag as addToBagAction } from 'models/bag/actions'
import { TRACKING_ADDED_FROM_CANVAS_ACTION } from 'models/tracking/constants'
import SugarcubeContext from 'apps/SugarcubeContext'

import ActionPanel from 'components/design/ActionPanel'

const ActionPanelContainer = ({
    selectedId,
    targetRef,
    onDelete,
    onRotateStart,
    onRotate,
    onRotateFinish,
    onDuplicate,
    onChangeSurface,
    heading,
    localItemNumber,
    region,
    trackingInfo,
    name,
    addToBag,
}) => {
    const { isKiosk } = useContext(SugarcubeContext)

    const onAddToCart = isKiosk
        ? null
        : () =>
              addToBag(localItemNumber, region, name, {
                  ...trackingInfo,
                  AddedFrom: TRACKING_ADDED_FROM_CANVAS_ACTION,
              })
    return (
        <ActionPanel
            selectedId={selectedId}
            targetRef={targetRef}
            onDelete={onDelete}
            onRotateStart={onRotateStart}
            onRotate={onRotate}
            onRotateFinish={onRotateFinish}
            onDuplicate={onDuplicate}
            onChangeSurface={onChangeSurface}
            heading={heading}
            onAddToCart={onAddToCart}
            localItemNumber={localItemNumber}
        />
    )
}

ActionPanelContainer.defaultProps = {
    selectedId: null,
    onDelete: null,
    onRotate: null,
    onRotateStart: null,
    onRotateFinish: null,
    onDuplicate: null,
    onChangeSurface: null,
    heading: null,
}

ActionPanelContainer.propTypes = {
    selectedId: number,
    targetRef: shape({}).isRequired,
    onDelete: func,
    onRotateStart: func,
    onRotate: func,
    onRotateFinish: func,
    onDuplicate: func,
    onChangeSurface: func,
    heading: number,
    localItemNumber: string.isRequired,
    region: string.isRequired,
    trackingInfo: shape({}).isRequired,
    name: string.isRequired,
    addToBag: func.isRequired,
}

const mapStateToProps = (state) => ({
    selectedId: getSelectedRenderItemId(state),
})

const mapDispatchToProps = {
    addToBag: addToBagAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionPanelContainer)
